import React from "react";
import { ArrowButton } from "../../components/arrow-button";

interface HidayetGunesiProps {
    isVisible: boolean;
    comeBackSemaSection: Function;
}

const HavradanKilisedenCamiye = (props: HidayetGunesiProps) => {
    return (
        <div style={{ display: props.isVisible ? "block" : "none" }}>
            <article>
                <ArrowButton onClick={props.comeBackSemaSection} />
                <h3 className="title">HAVRA’DAN KİLİSE’DEN CAMİ’YE</h3>

                <p>
                    Elinizdeki çalışma, dünyada İslam’ı seçen bazı din
                    adamlarının hidayet öykülerini konu almaktadır. Bu
                    zatların her biri, Müslüman olmadan önce birer din
                    adamıdır. İstisnasız hepsi de dinlerine adam kazandırmaya
                    çalışan birer misyonerdir, hatta bazıları kardinal
                    veya başpiskopos seviyesinde yüksek görevlere sahip
                    kişilerdir. Acaba böylesine dinlerine bağlı, kendi inançlarına
                    başka hayatları davet etmek için çabalayan, bu
                    uğura hayatlarını adayan, bu yolda büyük imkân, itibar
                    ve üne kavuşmuş olan bu şahıslar neden İslam’ı
                    seçtiler? Hiç kuşku yok ki bu, kolay alınabilecek karar
                    değildir. Sosyal çevrelerini, hatta bazen en sevdiklerini
                    yitirme ve yapayalnız kalmayı göze alarak bu yolu seçmişlerdir.
                    Demek ki onları buna sevk eden çok kuvvetli
                    bir hakikat olmalıdır. Gerekçelerini incelediğimizde ise
                    şu hususların ön plana çıktığını görürüz;
                </p>
                <p>
                    Karşılarında İslam’ı güzelce temsil eden, İslam ahlakını
                    hayatlarında yaşayan bir örnek bulunması onları
                    İslam dinine sevk etmektedir. Bu da gösteriyor ki İslam
                    ahlakını ve imanın güzelliklerini davranışlarımızla sergilersek
                    diğer dinlerin mensupları grup grup İslam’a
                    gireceklerdir.
                </p>

                <p>
                    Müslümanların camileri, cemaatleri, oruçları ve
                    ibadet esnasındaki hâllerine hayran kalıp ihtida kararını
                    hızlandıran kişiler için şu ifadeler söylenebilir:
                </p>

                <p>
                    Hristiyanlıktan iyice soğuduktan sonra neler okuduklarını
                    anlamasalar da Müslümanların namazdaki
                    duruşları, derin saygı ve intizamları, bulundukları
                    mekânı kaplayan manevî hava onları cezp
                    ediyordu. Özellikle Kur’an okunduğunda hemen ilgilerini
                    çeker ve içlerine hidayet güneşi yansırdı.
                    Oysa Müslümanlardan nefret üzere yetiştirilmişlerdi.
                    Müslümanların Ramazan ayında tuttukları oruca
                    da hayranlardı. Bunu, Hıristiyanların tuttukları, ama
                    Kitab-ı Mukaddes’te yeri olmayan sıyâmu’z-zeyt orucundan
                    çok daha anlamlı bulup henüz Müslüman olmadan
                    bile zaman zaman Ramazan’da oruç tutanlar
                    vardı.
                </p>

                <p>
                    Cami ile kiliseyi mukayese ederek camideki engin
                    ruhanî hayattan etkilenip Müslüman olanlar var.
                    Onlardan birisi şu açıklamayı yapmaktadır: “Yolumun
                    üzerinde bir cami vardı. Zaman zaman yanına yaklaşır,
                    içine göz atar, kiliseye hiç benzemediğini görürdüm. Ne
                    sandalyeler, ne heykel ve resimler, ne büyük avizeler,
                    ne pahalı halılar, ne musiki ve çalgı âletleri ne de alkış
                    vs. vardı. Bu camilerde ibadet yalnızca Allah’a rükû ve
                    secdeden ibaretti. Zenginle fakir ayrımı olmaz, herkes
                    dümdüz saflarda yan yana ibadete dururdu. Tüm bunlar,
                    kiliselerde yapılan davranışlarla karşılaştırıldığında
                    gözümde her zaman cami üstün gelirdi.”
                </p>

                <p>
                    İhtida öykülerini sunduğumuz kişiler arasında
                    Kur’an’dan etkilenerek Müslüman olanlar çoğunluktadır.
                    Bunların bir kısmı Kur’an’ın, indiğinden bu yana
                    hiç değişmediğini, bir kısmı Allah’ın birliğine yaptığı
                    vurguyu, bir kısmı ihtiva ettiği bilimsel gerçekleri, bir
                    kısmı ise İncillerin sayıca çok, Kur’an’ın ise tek olduğunu
                    görerek Müslüman olmuştur. İşte bir tespit:
                </p>

                <p>
                    “Genel olarak insanları İslam’dan alıkoyan bazı faktörler
                    var. Bunların başında, İslam hakkında edinilmiş
                    yanlış fikirler geliyor. Birçok Müslüman’ın söz ve davranışlarıyla
                    İslam hakkında, zihinlerde meydana getirdiği
                    kötü imaj da önemli bir engel oluşturmaktadır.
                    Bazı Müslümanların bilgisizce verdikleri fetvalar da
                    olumsuz etki yapmaktadır.
                </p>

                <p>
                    Son olarak, İslam hakkında ileri sürülen asılsız şüphe
                    ve suçlamalar da insanların İslam’dan uzak durmalarına
                    sebep oluyor. İslam’ın terör ve şiddeti teşvik
                    ettiği vb. şüpheler bunların sadece birkaçıdır. Hiç şüphesiz
                    bu suçlamaların hepsi taraflı ve yanlıştır. Fakat
                    ne yazık ki bu konularda kitaplar yazılmakta ve gayr-i
                    Müslim çevrelerde propagandası yapılmakta, böylece
                    insanlar İslam’dan soğutulmaktadır.
                </p>

                <p>
                    İşte burada biz Müslümanlara, İslam’ın o güzel ve
                    parlak olan gerçek imajının oluşmasında, şüphe tozlarının
                    silinmesinde ve yıkıcı medyanın insanların özgürce
                    Allah’ın hak dini olan İslam’ı tanımalarını engellemek
                    için ördüğü kaim surları yıkmada büyük iş
                    düşmektedir.”
                </p>

                <p>
                    Tasavvuf ilmi şeriat içerisinde Allah’a giden en kestirme
                    yoldur. İslam’la müşerref olan insanlar camilerde,
                    zaviyelerde, dergâhlarda ve çeşitli tasavvuf mahfillerinde
                    zikirden, sohbetten, semadan, dini musikiden
                    etkilendiklerini ifade ediyorlar. Çünkü tasavvuf sevgi
                    üzerine kurulmuştur. Aşk, sevgi, muhabbet… Sufîlerin
                    bütün arzusu yaratılanı sevmektir. Âşık Yunus’un deyişiyle
                    “Biz yaratılanı severiz Yaradan’dan ötürü…”Sufî
                    yolu, bir yaşayan süreç bir hayatın okuludur. Bu okul
                    insanlara ego zırhından nasıl kurtulacağını ve güneşin
                    arkasındaki güneşi nasıl arayacağını göstermektedir.
                </p>

                <p>
                    Sufîler’in ibadetleri, zikirleri, semaları, secdeleri,
                    yürüyüşleri, duruşları, giyim kuşamları, dervişlerin
                    birbirlerine olan latif ve nazik davranışları, edebî yaşantıları
                    ve bunun gibi birçok hasletlerinden ve bilhassa
                    Hz.Mevlana’nın: “Gel, gel… Ne olursan ol
                    yine gel. Yüz bin defa tövbeni bozmuş olsan da
                    yine gel… Bizim dergâhımız ümitsizlik dergâhı
                    değildir.” çağrısından etkilendiklerini ifade ederek
                    iman edenler var.
                </p>

                <p>
                    Mevlevîlerin veya diğer tarikatlerin yaptığı ibadet,
                    zikir, sema, musıkî icralarına şahid olanlar İslam’la
                    müşerref oluyorlar. Bazılarının ifadesi:
                </p>

                <p>
                    “Sufîlik manevî bakımdan insanı ham bulunduğu
                    bir noktada teslim alır. Siz de bu yolun gidilip gidilemeyeceğini
                    denemeye davetlisiniz. Halis niyetle birlikte,
                    bilgi, teslimiyet ve icraatın yanında sohbet, öğrenmenin
                    diğer bir sütunudur.”
                </p>

                <p>
                    Ruh beden ilişkisinde beden ruhumuzun akıl evidir.
                    Ruh, bedeni kullanarak bu evde kendisinden bekleneni
                    gerçekleştirir. Bu görevi yerine getirirken, en büyük
                    yardım malzemesi olarak kendisine emanet edilen beden,
                    ruhun bu âlemde kullanımına sunulmuş muazzam
                    bir aparat ve düzenekler bütünüdür.
                </p>

                <p>
                    Üst düzey görevlere getirilen kişiler Allah’ın hidayetine
                    erişiyor. İşte bu ruh aparatlarını kullanarak hür
                    iradeyle İslam’la müşerref oluyorlar.
                </p>

                <p className="text-bold">
                    İnsan akıl aparatıyla anlar, vicdanla
                    tartarak karar verir, hayal ile planlar yapar,
                    hafıza ile bilgi depolar, kalp ile sever…
                </p>

                <p className="text-bold">
                    Muhakeme-i diniyye ile karar verir.
                </p>

                <p>
                    Dünyada İslam’ın hayat bahşedici gerçeklerine hava
                    kadar, su kadar ihtiyacı olan insanlara İslam’ı sunarken
                    nelere dikkat edilmesi gerektiğini de hidayete eren
                    bu zatlardan öğreniyoruz. İşte bu şahıslardan birinin
                    önerileri:
                </p>

                <p>
                    “İslamî ahlakı yaşayarak ve bu ahlaka uygun davranarak
                    insanları, İslam’a davet etmeli. Tevhit inancına
                    ilgi duyup İslam’ı kabul edenlerin büyük çoğunluğu,
                    Müslümanların örnek davranışlarından etkilenerek bu
                    kararı vermişlerdir. Bundan dolayı, insanların İslam’a
                    güzelce ve tatlılıkla davet edilmesini tavsiye ediyorum.
                    Aceleci davranmaktan da kaçınılmalıdır. Çünkü atılan
                    hiçbir tohum bir günde filizlenmez.”
                </p>

                <p>
                    Her biri önümüzde birer ders ve ibret levhası gibi
                    duran ihtida öykülerinden sunduğumuz bu kısa alıntılar
                    birer tadımlıktı. Daha fazla meşgul etmeden, büyük
                    bir zevk ve heyecanla bir solukta okunacak ve çok istifade
                    edilecek gerçek hidayete ermiş, imana yolculuk
                    yapanların ihtida öyküleriyle sizi baş başa bırakıyorum.
                </p>
                <p className="text-bold">
                    Saygılarımla...<br />
                    <div style={{ textAlign: "right" }}>
                        Araştırmacı Yazar<br />
                        El-Hacc<br />
                        Ali Yakub Babacan
                    </div>

                </p>
            </article>
        </div>
    );
}

export default HavradanKilisedenCamiye;